import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';

import esLocale from '@fullcalendar/core/locales/es';
import itLocale from '@fullcalendar/core/locales/it';

document.addEventListener('DOMContentLoaded', function () {
  const calendarElement = document.getElementById('calendar');
  const calendarButton = document.getElementById('calendar-button');
  const scheduleSection = document.querySelector('.schedule-section-show');

  if (calendarData) {
    window.calendar = new Calendar(calendarElement, {
      plugins: [dayGridPlugin, interactionPlugin],
      locales: [itLocale, esLocale],
      initialView: 'dayGridMonth',
      initialDate: Object.keys(calendarData)[0],
      height: 'auto',
      headerToolbar: {
        start: 'prev,next',
        center: 'title',
        end: 'today'
      },
      datesSet: function () {
        const clonedRows = document.querySelectorAll('tr.cloned');
        clonedRows.forEach(row => row.remove());

        const cells = document.querySelectorAll('.fc-daygrid-day');

        cells.forEach(cell => {
          const cellDate = cell.dataset.date;
          const eventsContainer = cell.querySelector('.fc-daygrid-day-events');

          if (eventsContainer) {
            eventsContainer.innerHTML = '';

            if (calendarData[cellDate]) {
              const eventCount = calendarData[cellDate].length;

              const eventCountContainer = document.createElement('div');
              eventCountContainer.className = 'event-count-message';

              if (eventCount === 1) {
                eventCountContainer.innerText = '1 Evento';
              } else {
                eventCountContainer.innerText = `${eventCount} Eventi`;
              }

              eventsContainer.appendChild(eventCountContainer);

              const eventDot = document.createElement('div');
              eventDot.className = 'event-dot';

              eventsContainer.appendChild(eventDot);

              cell.classList.add('with-events');
            }
          }
        });

        changeCellsStatus('unlock');
      },
      dateClick: function (info) {
        const clickedCell = info.dayEl;

        if (!clickedCell.classList.contains('with-events')) { return; }
        if (clickedCell.classList.contains('locked')) { return; }

        changeCellsStatus('lock');

        const clonedProjectionRowsExist = createProjectionRows(clickedCell);

        if (clonedProjectionRowsExist) {
          toggleRowsVisibility(clickedCell);
        } else {
          const date = clickedCell.dataset.date;
          const cinema = document.querySelector('.select-cinema.selected')?.dataset.target;
          const district = document.querySelector('.select-district.selected')?.dataset.target;
          const filmId = document.querySelector('input#film-id-show').value;

          $.ajax({
            type: 'GET',
            url: `/film/${filmId}/fetch_film_occupations`,
            timeout: 30000,
            cache: false,
            data: {
              calendar: true,
              date,
              cinema,
              district,
              invite_code: inviteCode
            },
            success: function () {
              toggleRowsVisibility(clickedCell);
            },
            error: function () {
              Swal.fire('', 'Al momento non è possibile caricare la programmazione dell\'evento. Per favore riprovare più tardi', 'error');
            }
          });
        }
      }
    });

    calendarButton.addEventListener('click', function () {
      let calendarVisible = !calendarElement.classList.toggle('d-none');
      scheduleSection.classList.toggle('d-none');

      if (calendarVisible) {
        document.querySelector('#calendar-button span').innerText = 'Elenco eventi';
        document.querySelector('#calendar-button i').className = 'fa fa-list';
        if (!window.calendar.isRendered) window.calendar.render();
      } else {
        document.querySelector('#calendar-button span').innerText = 'Calendario';
        document.querySelector('#calendar-button i').className = 'fa fa-calendar';
      }
    });

    document.addEventListener('click', function (event) {
      if (event.target && event.target.id === 'view-full-schedule-button') {
        document.getElementById('calendar-button').click();
        document.getElementById('schedule-beginning').scrollIntoView({ behavior: 'smooth' });
      }
    });

    function createProjectionRows(clickedCell) {
      const date = clickedCell.dataset.date;
      const existingRow = document.querySelector(`tr.cloned[data-date="${date}"]`);

      if (existingRow) { return true; }

      const projections = scheduleSection.querySelectorAll(
        `.event-select__item[data-date="${date}"]`
      );

      if (projections.length <= 0) { return false; }

      const clonedRow = document.createElement('tr');
      clonedRow.classList.add('cloned');
      clonedRow.setAttribute('data-date', date);

      const clonedColumn = document.createElement('td');
      clonedColumn.classList.add('schedule-section-show');
      clonedColumn.colSpan = 7;

      clonedRow.appendChild(clonedColumn);

      projections.forEach(projection => {
        const clonedProjection = projection.cloneNode(true);
        clonedProjection.classList.add('calendar-item');

        clonedColumn.appendChild(clonedProjection);
      });

      const parentRow = clickedCell.closest('tr');

      if (parentRow) { parentRow.insertAdjacentElement('afterend', clonedRow); }

      return true;
    }

    function toggleRowsVisibility(clickedCell) {
      const activeCell = document.querySelector('.fc-daygrid-day.active');
      const date = clickedCell.dataset.date;

      if (activeCell) {
        activeCell.classList.remove('active');

        const activeCellDate = activeCell.dataset.date;

        if (activeCell !== clickedCell) {
          hideProjectionsRow(activeCellDate, () => {
            clickedCell.classList.add('active');

            showProjectionsRow(date);
          });
        } else {
          hideProjectionsRow(activeCellDate);

          const scheduleBeginningElement = document.getElementById("schedule-beginning");

          scrollTo(scheduleBeginningElement);
        }
      } else {
        clickedCell.classList.add('active');

        showProjectionsRow(date);
      }
    }

    function showProjectionsRow(date, callback = changeCellsStatus) {
      const row = document.querySelector(`tr.cloned[data-date="${date}"]`);

      if (row) { $(row).fadeIn(300, callback); scrollTo(row); }
    }

    function hideProjectionsRow(date, callback = changeCellsStatus) {
      const row = document.querySelector(`tr.cloned[data-date="${date}"]`);

      if (row) { $(row).fadeOut(300, callback); }
    }

    function changeCellsStatus(action = 'unlock') {
      const cells = document.querySelectorAll('.fc-daygrid-day.with-events');

      if (action === 'lock') {
        cells.forEach(cell => cell.classList.add('locked'));
      } else if (action === 'unlock') {
        cells.forEach(cell => cell.classList.remove('locked'));
      }
    }

    function scrollTo(element) {
      if (element.id == 'schedule-beginning') {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      } else {
        element.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }
  }
});